<template>
  <div class="top-bar">
    <div class="-intro-x breadcrumb mr-auto hidden sm:flex">
      <a>{{ $t('nav.main') }}</a>
      <ChevronRightIcon class="breadcrumb__icon" />
      <a class="breadcrumb--active">{{ title }}</a>
    </div>

    <DropDown
      class="intro-x w-8 h-8 relative"
      toggler-class="w-8 h-8 rounded-full overflow-hidden shadow-lg image-fit zoom-in"
      box-class="w-56"
      content-class="bg-theme-38 text-white p-0"
      toggler-tag="div"
    >
      <template #toggler>
        <img src="./../../assets/images/profile-default.jpg" />
      </template>

      <div class="p-4 border-b border-theme-40 dark:border-dark-3">
        <div class="font-medium">
          <template v-if="isProfileLoaded">{{ me | fullName }}</template>
        </div>
      </div>
      <div class="p-2">
        <a
          class="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3 rounded-md"
        >
          <UserIcon class="w-4 h-4 mr-2" />Profile
        </a>
        <a
          class="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3 rounded-md"
        >
          <EditIcon class="w-4 h-4 mr-2" />Add Account
        </a>
        <a
          class="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3 rounded-md"
        >
          <LockIcon class="w-4 h-4 mr-2" />Reset Password
        </a>
        <a
          class="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3 rounded-md"
        >
          <HelpCircleIcon class="w-4 h-4 mr-2" />Help
        </a>
      </div>
      <div class="p-2 border-t border-theme-40 dark:border-dark-3">
        <a
          href
          @click="logout"
          class="flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3 rounded-md"
        >
          <ToggleRightIcon class="w-4 h-4 mr-2" />
          {{ $t('auth.logout') }}
        </a>
      </div>
    </DropDown>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { AUTH_LOGOUT } from '@/store/actions/auth';
import humps from 'humps';
import DropDown from '@/components/ui/DropDown';

export default {
  name: 'TopBar',

  components: { DropDown },

  computed: {
    ...mapGetters(['me', 'isProfileLoaded']),
    title() {
      if (this.$route.meta?.title) {
        return this.$t(`nav.${humps.camelize(this.$route.meta.title)}`);
      }
      return this.$t(`nav.${humps.camelize(this.$route.name)}`);
    },
  },

  methods: {
    async logout() {
      await this.$store.dispatch(AUTH_LOGOUT);
    },
  },
};
</script>
